import { StoreId, StoreItemResponse, StorelineItemResponse, StoreResponse, StoreSectionResponse, StoreUrlRequest } from '@business/entities/store';
import { Endpoint } from '../endpoint';

export function fetchStores() {
  return Endpoint.get<StoreResponse[]>(`@gc/store`);
}

export function fetchStore(id: StoreId) {
  return Endpoint.get<StoreResponse>(`@gc/store/store/${id}`);
}

export function createStore(store: Partial<StoreResponse>) {
  return Endpoint.post<StoreResponse>(`@gc/store`, { data: { ...store } });
}

export function updateStore(id: StoreId, store: Partial<StoreResponse>) {
  return Endpoint.patch<StoreResponse>(`@gc/store/${id}`, { data: { ...store } });
}

export function updateStoreUrls(id: StoreId, urls: StoreUrlRequest[]) {
  return Endpoint.patch<StoreResponse>(`@gc/store/urls/${id}`, { data: { urls: urls } });
}

export function deleteStore(id: StoreId) {
  return Endpoint.delete<void>(`@gc/store/${id}`);
}

/** Section **/
export function createSection(id: StoreId, data: Partial<StoreSectionResponse>) {
  return Endpoint.post<void>(`@gc/store/section/${id}`, { data: data });
}

export function updateSection(id: number, data: Partial<StoreSectionResponse>) {
  return Endpoint.patch<void>(`@gc/store/section/${id}`, { data: data });
}

export function deleteSection(id: number) {
  return Endpoint.delete<void>(`@gc/store/section/${id}`);
}

export function sortSections(ids: number[]) {
  return Endpoint.post<void>(`@gc/store/sort-section`, { data: { ids } });
}

/** Step **/
export function createItem(id: StoreId, data: Partial<StoreItemResponse>) {
  return Endpoint.post<void>(`@gc/store/step/${id}`, { data });
}

export function updateItem(id: number, data: Partial<StoreItemResponse>) {
  return Endpoint.patch<void>(`@gc/store/step/${id}`, { data });
}

export function deleteItem(id: number) {
  return Endpoint.delete<void>(`@gc/store/step/${id}`);
}

export function sortItems(ids: number[]) {
  return Endpoint.post<void>(`@gc/store/sort-step`, { data: { ids } });
}

/** Line Item **/
export function creteLineItem(id: number, lineItems: Partial<StorelineItemResponse>[]) {
  return Endpoint.post<void>(`@gc/store/line-item/${id}`, { data: { lineItems } });
}

export function updateLineItem(id: number, data: Partial<StorelineItemResponse>[]) {
  return Endpoint.patch<void>(`@gc/store/line-item/${id}`, { data });
}

export function deleteLineItem(id: number) {
  return Endpoint.delete<void>(`@gc/store/line-item/${id}`);
}

// export function sortLineItem(ids: number[]) {
//   return Endpoint.post<void>(`@gc/store/sort-line-item`, { data: { ids } });
// }

export function sortLineItem(id: number, ids: number[]) {
  return Endpoint.post<void>(`@gc/store/sort-line-item/${id}`, { data: { ids } });
}

export function duplicateStore(id: StoreId, name: string) {
  return Endpoint.post<StoreResponse>(`@gc/store/duplicate/${id}`, { data: { name } });
}
